import styled from 'styled-components';

export interface PriorityNumberProps {
  priority: number | string;
}

const Background = styled.div`
  background-color: ${({ theme }) => theme.designToken.primary300};
  color: ${({ theme }) => theme.designToken.baseWhite};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PriorityNumber = ({ priority }: PriorityNumberProps) => {
  return <Background>{priority}</Background>;
};
